export enum TIER_ID {
  IDENTITY_KYC_TIER_ID = '1',
  PROOF_OF_ADDRESS_KYC_TIER_ID = '2',
  ACCREDITATION_KYC_TIER_ID = '3',
  NONE = '0',
}
